// extracted by mini-css-extract-plugin
module.exports = {"mobileDownloadAppText":"MobileDownloadAd__mobileDownloadAppText___3kgav","adContainer":"MobileDownloadAd__adContainer___1uV5r","closeIcon":"MobileDownloadAd__closeIcon___3nZcV"};